export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7954.9b4e99f6.jpg";